import { DeliveryOffer } from '@/productDiscovery/ProductPage/common/modules/Delivery/delivery.ducks';

export const useIsProductEligibleForSubscriptionDiscount = (
  offer: DeliveryOffer,
) => {
  if (!offer) return false;
  const isOfferFree = offer.deliveryPrice.amount === 0;

  const isOfferExpress = offer.isExpress;

  return !isOfferFree && !isOfferExpress;
};
